import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer, colorBins } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';

export const JOBACCESS45MINUTETRANSIT_LAYER_ID = 'jobAccess45MinuteTransitLayer';

const layerConfig = {
  title: 'Job Access 45 Minute Transit Difference',
};

function JobAccess45MinuteTransitLayer() {
  const dispatch = useDispatch();
  const { jobAccess45MinuteTransitLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, jobAccess45MinuteTransitLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (jobAccess45MinuteTransitLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: JOBACCESS45MINUTETRANSIT_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: jobAccess45MinuteTransitLayer.visible,
      opacity: jobAccess45MinuteTransitLayer.opacity,
      getFillColor: colorBins({
        attr: 'job_access_45minute_transit_diff',
        domain: [-55892, -19311.953, -4400.052, 0, 7000, 8937.348, 26495],
        colors: [
          [178, 34, 34],
          [255, 0, 0],
          [255, 102, 102],
          [255, 204, 204],
          [224, 224, 255],
          [153, 204, 255],
          [51, 102, 255],
          [0, 0, 128],
        ],
      }),
      pointRadiusMinPixels: 5,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: JOBACCESS45MINUTETRANSIT_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              includeColumns: ['job_access_45minute_transit_diff', 'geo_level_id'],
            }),
          };
        }
      },
    });
  }
}

export default JobAccess45MinuteTransitLayer;
